export default __webpack_public_path__ + "img/404.c65fadac.jpg";